<template>
    <div class="userLogin">
        <div class="downApp" v-if="!appLoad">
            <form class="downBtn">
                <div class="formLine">
                    <img src="@/assets/app/down3.png" alt="" @click.prevent="userQuerySIM1">
                    <mt-button type="primary" size="large" @click.prevent="userQuerySIM1">安卓版下载</mt-button>
                </div>
                <div class="formLine">
                    <img src="@/assets/app/down2.png" alt="" @click.prevent="userQuerySIM12">
                    <mt-button type="primary" size="large" @click.prevent="userQuerySIM12">苹果版下载</mt-button>
                </div>
                <mt-button type="primary" size="large" @click.prevent="seeLoad">苹果安装教程</mt-button>
            </form>
        </div>
        <div class="wxMessenger" v-else>
            <img src="@/assets/app/down.png" alt="">
        </div>
    </div>
</template>
<script type='text/javascript'>
(function (m, ei, q, i, a, j, s) {
    m[i] = m[i] || function () {
        (m[i].a = m[i].a || []).push(arguments)
    };
    j = ei.createElement(q),
        s = ei.getElementsByTagName(q)[0];
    j.async = true;
    j.charset = 'UTF-8';
    j.setAttribute("data-json", JSON.stringify({
        id: 1277,
        token: 'fba5373a8a9896eebcf972ebc87164f0',
        image: '/static/home/img/logo_x120.png'
    }));
    j.id = "xiaokefu_js";
    j.src = 'https://pcjs.xiaokefu.com.cn/static/pc_Access/dist/pcAccess.js?version=' + parseInt(new Date().getTime() / 3600000);
    s.parentNode.insertBefore(j, s);
})(window, document, 'script', '_xiaokefu');
</script>
<script>
import { wxRequest } from '@/api/user'
import { Toast,Dialog } from 'vant';
export default {
    data(){
        return {
            appLoad:false,
        }
    },
    methods: { 
        seeLoad(){
            this.$router.push('/user/AppASee')
        },
        userQuerySIM12(){
        var ua = window.navigator.userAgent.toLowerCase();
        //通过正则表达式匹配ua中是否含有MicroMessenger字符串
        if(ua.match(/MicroMessenger/i) == 'micromessenger'){
            this.appLoad=true;
            return;
        } 

            wxRequest("order/load/app/log", {agentName:"pingguo"}, "post").then(res => {
            })
            window.location.href ='http://app.iot688.cn/loadp/app.mobileconfig'
        }, 
        userQuerySIM1(){
             //通过正则表达式匹配ua中是否含有MicroMessenger字符串
        var ua = window.navigator.userAgent.toLowerCase();
        if(ua.match(/MicroMessenger/i) == 'micromessenger'){
            this.appLoad=true;
            return;
        } 
            wxRequest("order/load/app/log", {agentName:"anzuo"}, "post").then(res => {
            })
            window.location.href ='http://app.iot688.cn/loada/app.apk'
        },
    },
    created(){
       
    }
}
</script>


<style scoped lang="less">
.userLogin {
    height: 100%;
    position: relative;
}

.wxMessenger {
    position: absolute;
    top: 0;
    right: 0;
    height: 100%;
    background: #000;

    img {
        width: 100%;
    }
}

.downApp {
    height: 100%;
    width: 100%;
    background: url('./../../assets/app/app.jpg') no-repeat top center;
    background-size: 100% 100%;
    position: relative;

    .downBtn {
        position: absolute;
        right: 20px;
        top: 40%;

        .formLine {
            margin-bottom: 12px;
            text-align: center;
        }

        img {
            width: 80px;
            height: 80px;
            margin-bottom: 8px;
        }

        .mint-button {
            border-radius: 20px;
            font-size: 14px;
            padding: 0 10px;
            background: #fb1834;
        }
    }
}
</style>